import { faAngleRight as lightAngleRight } from "@jewlr/pro-light-svg-icons/faAngleRight"
import { faTimes as lightTimes } from "@jewlr/pro-light-svg-icons/faTimes"
import PropTypes from "prop-types"
import { useState } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import { removeFromCart } from "app-store-v2/header/actions"
import Confirmation from "components/ui/confirmation"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import { jewlr_t } from "helpers/application"

import {
  ItemAction,
  CardItemInfo,
  CardTitle,
  Card,
  CardRemove,
} from "../components"

import LineAddonPrice from "./line-addon-price"

const InternalLineItemAddon = ({ item, removeAddonItem, addon }) => {
  if (!addon) return false
  const [showRemoveDialog, toggleRemoveDialog] = useState(false)

  return (
    <Card className="mt-24 pt-24">
      <CardRemove
        data-cy={`cart-remove-btn-mobile-${item.style_code}`}
        onClick={() => toggleRemoveDialog(true)}
      >
        <FontAwesomeIcon icon={lightTimes} />
      </CardRemove>
      <Confirmation
        cancelText="Cancel"
        confirmText="Yes"
        description={`Are you sure you want to remove this item from your ${jewlr_t(
          "Cart"
        )}?`}
        onCancel={() => toggleRemoveDialog(false)}
        onConfirm={() => {
          removeAddonItem(addon.id)
          toggleRemoveDialog(false)
        }}
        show={showRemoveDialog}
        title="Remove Item"
      />
      <CardTitle data-lc="line-item-addon" to={addon.modify_url}>
        {addon.title}
      </CardTitle>
      <div className="mt-8 flex items-end">
        <div className="w-1/2">
          <Link data-lc="line-item-addon" to={addon.modify_url}>
            {addon.image_url?.startsWith("https://user-uploads.jewlr.com") ? (
              <Image
                alt={addon.title}
                className="bg-black p-8"
                data-cy={`cart-line-item-box-img-mobile-${item.style_code}`}
                height="145px"
                src={addon.image_url}
                width="145px"
              />
            ) : (
              <Image
                alt={addon.title}
                data-cy={`cart-line-item-box-img-mobile-${item.style_code}`}
                height="145px"
                src={addon.image_url}
                width="145px"
              />
            )}
          </Link>
        </div>
        <CardItemInfo className="w-1/2 text-right">
          <LineAddonPrice
            displayPrice={addon.price}
            retailPrice={addon.retail_price}
            showSavings={addon.price != addon.retail_price}
          />
          <div className="text-link tablet:text-14 mb-40">
            <ItemAction asChild>
              <Link
                data-lc="line-item-addon"
                to={`${addon.modify_url}&panel=box`}
              >
                Modify Item{" "}
                <FontAwesomeIcon
                  className="align-text-bottom"
                  icon={lightAngleRight}
                />
              </Link>
            </ItemAction>
          </div>
        </CardItemInfo>
      </div>
    </Card>
  )
}

InternalLineItemAddon.propTypes = {
  addon: PropTypes.object,
  item: PropTypes.object,
  removeAddonItem: PropTypes.func,
  toggleInstantGiftPreview: PropTypes.func,
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    removeAddonItem: (addonId) => {
      dispatch(removeFromCart(addonId, true))
    },
  }
}

const LineItemAddon = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalLineItemAddon)

export default LineItemAddon
